import { combineReducers } from 'redux';
import activityLogReducer from '../features/activitylog/redux/activityLogSlices';
import agreementReducer from '../features/agreement/redux/agreementSlices';
import basePriceReducer from '../features/baseprice/redux/basePriceSlices';
import calculationReducer from '../features/calculation/redux/calculationSlices';
import customersReducer from '../features/customer/redux/customerSlices';
import customerGroupsReducer from '../features/customergroups/redux/customerGroupSlices';
import externalPriceReducer from '../features/externalprice/redux/externalPriceSlices';
import externalPricelistReducer from '../features/externalpricelist/redux/externalPricelistSlices';
import inactivatePricesReducer from '../features/inactivateprices/redux/inactivatePricesSlices';
import priceReducer from '../features/price/redux/priceSlices';
import pricelistReducer from '../features/pricelist/redux/pricelistSlices';
import productReducer from '../features/product/redux/productSlices';
import settingsReducer from '../features/settings/redux/settingsSlices';
import stockReducer from '../features/stock/redux/stockSlices';
import uiReducer from '../features/ui/redux/uiSlices';
import userReducer from '../features/user/redux/userSlices';
import userGroupReducer from '../features/usergroup/redux/userGroupSlices';
import contactsReducer from '../features/contacts/redux/contactsSlices';
import tagReducer from '../features/tags/redux/tagSlices';
import exchangeRateReducer from '../features/exchangerates/redux/exchangeRateSlices';

const rootReducer = combineReducers({
    basePrice: basePriceReducer,
    price: priceReducer,
    pricelist: pricelistReducer,
    customers: customersReducer,
    calculation: calculationReducer,
    product: productReducer,
    ui: uiReducer,
    stock: stockReducer,
    user: userReducer,
    userGroup: userGroupReducer,
    externalPricelist: externalPricelistReducer,
    externalPrice: externalPriceReducer,
    agreement: agreementReducer,
    customerGroups: customerGroupsReducer,
    settings: settingsReducer,
    inactivatePrices: inactivatePricesReducer,
    activityLog: activityLogReducer,
    contacts: contactsReducer,
    tags: tagReducer,
    exchangeRates: exchangeRateReducer
});

export default rootReducer;
